import { CommentDto } from '../../../services/Campaign/campaignService.dto';
import { campaignService } from '../../../services/Campaign/campaignService';
import { useBackendData } from '../../../services/useBackendData';

export const useCommentDetails = (commentId?: number, commentDto?: CommentDto) => {
  const { data: comment, isLoading } = useBackendData({
    queryKey: ['comment', commentId],
    queryFn: () => campaignService.fetchComment(commentId!).then(res => res.data),
    enabled: !commentDto && !!commentId,
    initialData: commentDto,
  });

  return { comment, isLoading };
};
